import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import * as React from 'react';

import { mono } from '../components';

/** A part of a connection card: a hairline above, its heading, then the content (more room above the
 *  heading than below it). `contentId` names the content, for an action that shows or hides it (`aria-controls`). */
export const CardSection = ({ title, actions, children, testId, contentId }: {
    title: string;
    actions?: React.ReactNode;
    children: React.ReactNode;
    testId?: string;
    contentId?: string;
}) => (
    <Box component="section" aria-label={title} sx={{ borderTop: 1, borderColor: 'divider', pt: 2, mt: 2 }} data-testid={testId}>
        <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 1, rowGap: 1, minHeight: 30 }}>
            <Typography variant="subtitle2" component="h3" sx={{ fontWeight: 500, flexGrow: 1 }}>{title}</Typography>
            {actions}
        </Stack>
        {contentId ? <Box id={contentId}>{children}</Box> : children}
    </Box>
);

/** Close with unsaved changes asks first (review I5 #12): nothing typed is dropped silently. */
export const DiscardPrompt = ({ onDiscard, onKeep }: { onDiscard: () => void; onKeep: () => void }) => (
    <Alert
        severity="warning"
        sx={{ my: 1 }}
        data-testid="discard-prompt"
        action={(
            <Stack direction="row" spacing={0.5}>
                <Button color="inherit" size="small" onClick={onKeep}>Keep editing</Button>
                <Button color="inherit" size="small" onClick={onDiscard}>Discard</Button>
            </Stack>
        )}
    >
        You have unsaved changes. Discard them?
    </Alert>
);

/** An account's name and slug, as the rows and the webhook groups show them. */
export const AccountName = ({ name, slug }: { name: string; slug: string | null }) => (
    <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" component="span" sx={{ fontWeight: 500 }}>{name}</Typography>
        {slug && <Typography variant="caption" color="text.secondary" component="span" sx={{ ...mono, fontSize: 12, ml: 1 }}>{slug}</Typography>}
    </Box>
);
